import { registerPlugin } from '@capacitor/core';
const Resgrid = registerPlugin('Resgrid', {
    web: () => import('./web').then(m => new m.ResgridWeb()),
});
export * from './definitions';
export { Resgrid };
//# sourceMappingURL=index.js.map